angular.module('gym.mobile_app').directive('mobileAppSettingsGeneral', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/general.html.slim'),
    scope: {
      setTab: '&'
    },
    controller: ["$scope", "$rootScope", "$state", "MobileApp", function($scope, $rootScope, $state, MobileApp) {
      var gym;
      gym = $rootScope.gym;
      $scope.currentTipIndex = 0;
      $scope.isAccountOwner = window.currentUser.account_owner;
      MobileApp.all('settings').getList().then(function(data) {
        $scope.settings = data.plain()[0];
        return $scope.tips = _.shuffle($scope.settings.setup_todos);
      });
      $scope.nextTip = function() {
        return $scope.currentTipIndex = $scope.tips[$scope.currentTipIndex + 1] ? $scope.currentTipIndex + 1 : 0;
      };
      $scope.toAccessSettings = function() {
        return $scope.setTab({
          tab: {
            name: 'access_settings'
          }
        });
      };
      $scope.toGeneralSettings = function() {
        return $state.go('gym.edit');
      };
      $scope.toDesignSettings = function() {
        return $scope.setTab({
          tab: {
            name: 'design'
          }
        });
      };
      return $scope.toProximityCheckinAddresses = function() {
        return $scope.setTab({
          tab: {
            name: 'proximity_checkin_addresses',
            subtab: true
          }
        });
      };
    }]
  };
});
